import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NgClass } from '@angular/common';

export interface dataStructure {
  id: number;
  username: string;
  email: string;
  picture: string;
  system: string;
}

@Component({
  selector: 'lib-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css'],
  standalone: true,
  imports: [NgClass]
})
export class LoginFormComponent implements OnInit, OnDestroy {
  @Input() content!: any;

  username: string | undefined = '';
  email!: string | undefined;
  so: any;
  soTransform: any;
  soCapture: any;

  disableBtn: boolean = false;

  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(private authService: MsalService) {}

  async ngOnInit() {
    await this.authService.instance.initialize();
    const loggedByMsal = this.authService.instance.getActiveAccount();

    // check if user is already logged in
    if (loggedByMsal) {
      this.email = loggedByMsal.username;
      this.username = loggedByMsal.name;
      this.so = window.navigator.userAgent;
      this.soTransform = this.so.split('(');
      this.soCapture = this.soTransform[1].split(';');

      this.authService.loginRedirect();
    }

    this.authService.instance.handleRedirectPromise().then((res) => {
      if (res != null && res.account != null) {
        this.authService.instance.setActiveAccount(res.account);
      }
    });
  }

  async login() {
    await this.authService.instance.initialize();
    await this.authService
      .loginPopup()
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: AuthenticationResult) => {
        if (response) {
          this.authService.instance.setActiveAccount(response.account);

          this.authService.loginRedirect();
        }
      });
  }

  // force disable in mailto
  disableBtnTime() {
    this.disableBtn = true;

    setTimeout(() => {
      this.disableBtn = false;
    }, 5000);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
